<template>
  <transition name="fade">
    <div v-if="isOpen" class="update-modal-overlay" @keydown.esc="close" tabindex="-1" ref="modalOverlay">
      <div class="update-modal" role="dialog" aria-modal="true" aria-labelledby="update-title">
        <div class="update-modal-icon">
          <img src="@/assets/img/update.png" :alt="$t('update_modal.icon_alt')" />
        </div>
        <h2 id="update-title" class="update-modal-title">{{ $t("update_modal.title") }}</h2>
        <p class="update-modal-desc">
          {{ $t("update_modal.description") }}
        </p>
        <div class="update-modal-actions">
          <argon-button variant="fill" color="warning" @click="update" ref="updateBtn">{{ $t("update_modal.update_button") }}</argon-button>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import ArgonButton from '@/components/ArgonButton.vue'

export default {
  name: "UpdateModal",
  components: {
    ArgonButton
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true
    }
  },
  emits: ["update"],
  mounted() {
    this.focusTrap();
  },
  watch: {
    isOpen(val) {
      if (val) {
        this.$nextTick(this.focusTrap);
      }
    }
  },
  methods: {
    update() {
      this.$emit("update");
    },
    focusTrap() {
      if (this.isOpen) {
        const updateBtn = this.$refs.updateBtn;
        if (updateBtn && updateBtn.$el) updateBtn.$el.focus();
      }
    },

  }
};
</script>
<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
.update-modal-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0, 0, 0, 0.797);
  z-index: 11000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.update-modal {
  background: #060f2d;
  border-radius: 1.2rem;
  box-shadow: 0 10px 40px rgba(0,0,0,0.25), 0 4px 10px rgba(0,0,0,0.1);
  padding: 2.5rem 1.5rem 1.5rem 1.5rem;
  max-width: 370px;
  width: 90vw;
  position: relative;
  text-align: center;
  outline: none;
}
.update-modal-icon {
  position: absolute;
  left: 50%;
  top: -35px;
  transform: translateX(-50%);
  background: #fff;
  border-radius: 50%;
  box-shadow: 0 2px 12px rgba(0,0,0,0.10);
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}
.update-modal-icon img {
  width: 90px;
  height: 90px;
  object-fit: contain;
}
.update-modal-title {
  margin-top: 50px;
  font-size: 1.45rem;
  font-weight: 700;
  color: #2d3748;
  letter-spacing: 0.01em;
}
.update-modal-desc {
  margin: 1rem 0 1.5rem 0;
  font-size: 1.05rem;
  color: #808ea8;
  text-align: justify;
}
.update-modal-actions {
  display: flex;
  gap: 0.7rem;
  justify-content: flex-end;
}
.btn-neutral {
  background: #f5f6fa;
  color: #2d3748;
  border: none;
  border-radius: 5px;
  padding: 0.6rem 1.2rem;
  font-size: 1rem;
  font-weight: 500;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  cursor: pointer;
  transition: background 0.2s;
}
.btn-neutral:hover, .btn-neutral:focus {
  background: #e2e8f0;
}
.btn-accent {
  background: #fbad41;
  color: #fff;
  border: none;
  border-radius: 5px;
  padding: 0.6rem 1.2rem;
  font-size: 1rem;
  font-weight: 500;
  box-shadow: 0 2px 8px rgba(251,173,65,0.10);
  cursor: pointer;
  transition: background 0.2s;
}
.btn-accent:hover, .btn-accent:focus {
  background: #ffcd66;
}
@media (max-width: 500px) {
  .update-modal {
    padding: 2rem 0.5rem 1rem 0.5rem;
    max-width: 98vw;
  }
  .update-modal-title {
    font-size: 1.1rem;
  }
  .update-modal-icon {
    width: 60px;
    height: 60px;
    top: -30px;
  }
  .update-modal-icon img {
    width: 80px;
    height: 80px;
  }
}
</style>
